<div class="container py-5">
    <h1>Termos de Uso</h1>

    <ol class="pl-0">
        <li>Introdução
            <ol>
                <li>O Estudei é uma plataforma online para planejamento, gerenciamento e
                    compartilhamento de atividades de estudo. Ele é oferecido para você pela Seedy
                    Soluções Tecnológicas em Educação LTDA, “Seedy”, e seus parceiros.</li>
                <li>Os Termos de Uso e a Políticas de Privacidade se aplicam ao uso do serviço oferecido
                    pela plataforma Estudei pelos usuários e estão sujeitos a constantes melhorias e
                    aprimoramentos, de modo que recomendamos sua periódica consulta.</li>
                <li>Ao acessar e usar os serviços, você, como usuário, confirma que concorda com estes
                    Termos de Uso e a Política de Privacidade. Caso não concorde, você não está
                    autorizado a utilizar os serviços.</li>
            </ol>
        </li>

        <li>Cadastro e Identificação do Usuário
            <ol>
                <li>Para a adesão à plataforma, o usuário deverá se identificar por meio do
                    preenchimento completo dos dados cadastrais exigidos no site. O usuário é
                    responsável pelas informações fornecidas no momento de seu cadastro, não se
                    responsabilizando a Seedy por informações incorretas ou inverídicas por ele
                    apresentadas.</li>
                <li>Após aderir à assinatura, o usuário terá acesso à plataforma por meio de seu nome de
                    usuário (login) e senha, de uso exclusivo do usuário.</li>
                <li>É vedado ao usuário ceder a terceiros o uso de seu usuário (login) e senha de forma
                    gratuita ou onerosa sob pena de suspensão preventiva do acesso do usuário à
                    plataforma, até que sejam feitos os devidos esclarecimentos; e, não sendo
                    apresentado ou sendo insuficientes os esclarecimentos prestados, cancelar
                    definitivamente o acesso do usuário à plataforma de ensino, sem a devolução de
                    quaisquer valores.</li>
                <li>É responsabilidade do usuário o sigilo do seu login e de sua senha, para evitar o
                    acesso não autorizado de terceiros à plataforma, sendo ele o único responsável por
                    eventual uso inadequado decorrente de acessos indevidos.</li>
            </ol>
        </li>

        <li>Assinaturas
            <ol>
                <li>As assinaturas dão acesso ilimitado a todas as funcionalidades da plataforma.
                </li>
                <li>O período de vigência das assinaturas tem início a partir da data de aprovação do
                    pagamento.</li>
                <li>São aceitos pagamentos no cartão de crédito, em qualquer assinatura, e via PIX,
                    sempre à vista, para as assinaturas anuais.</li>
                <li>Uma vez efetuada a assinatura, ela será automaticamente renovada:
                    <ol>
                        <li>no mesmo dia e mês do ano subsequente, no caso da assinatura Anual.</li>
                        <li>Se a cobrança de quaisquer assinaturas for feita nos dias 29, 30 ou 31, as
                            renovações subsequentes serão feitas sempre no último dia de cada mês.</li>
                        <li>A renovação da assinatura é considerada realizada no momento em que gateway
                            de pagamentos utilizado pelo Estudei realiza a cobrança no cartão de crédito
                            do cliente e este recebe um e-mail de confirmação da compra realizada. Pode
                            ocorrer em qualquer horário do último dia do período vigente.</li>
                    </ol>
                </li>
                <li>A renovação de pagamentos realizados por PIX na assinatura Anual não é
                    feita de forma automática, exigindo que o usuário realize novamente o pagamento pela
                    plataforma.</li>
                <li>A "Seedy" poderá eventualmente alterar o preço de suas assinaturas, sendo certo que
                    irá notificar os usuários de forma antecipada. As alterações nos valores vão surtir
                    efeito no próximo período de renovação. O usuário concorda com o novo preço ao
                    continuar em utilizar a plataforma, caso não concorde tem o direito de rejeitar
                    cancelando a assinatura.</li>
                <li>A renovação da assinatura depende do pagamento antecipado do novo valor do período a
                    ser adquirido, seja por cartão (à vista ou parcelado) ou por PIX (exclusivamente à
                    vista).</li>
                <li>A assinatura fica ativa sempre pelo período contratado e, uma vez realizada, o prazo
                    corre de maneira ininterrupta, independentemente de o cliente utilizar ou não o
                    serviço.</li>
                <li>No caso de adesão feita em períodos promocionais, a renovação do acesso à plataforma
                    seguirá regras próprias, apresentadas em detalhes quando da promoção, aplicando-se,
                    no que couber, o disposto nos itens acima.</li>
            </ol>
        </li>

        <li>Cancelamento
            <ol>
                <li>Para o usuário cancelar sua assinatura, basta ir à seção de Assinaturas e clicar em
                    “Gerenciar”.</li>
                <li>Cancelamento no primeiro período de utilização:
                    <ol>
                        <li>Caso o pedido de cancelamento seja feito durante o prazo de 7 (sete) dias,
                            contados da primeira cobrança, e desde que seja o primeiro pedido de
                            cancelamento, o valor é devolvido integralmente, nos termos do art. 49 do
                            Código de Defesa do Consumidor. O acesso ao sistema, neste caso, é removido
                            imediatamente.</li>
                        <li>Caso o pedido de cancelamento seja feito após o prazo descrito no item
                            acima, ou, ainda, não for o primeiro pedido de cancelamento, não há
                            devolução do valor pago. Neste caso, o usuário continua com acesso regular
                            ao site, até o término do período já contratado. Findo este período, não
                            haverá nova cobrança recorrente, e o acesso ao site será finalmente
                            retirado.</li>
                    </ol>
                </li>
                <li>Cancelamento no segundo período de utilização em diante (renovações):
                    <ol>
                        <li>No caso de pedido de cancelamento a partir da primeira renovação em diante,
                            o valor já pago não é devolvido (não há aplicação do item 4.2.1 acima, que
                            trata do direito de arrependimento previsto no CDC).</li>
                        <li>Na situação acima descrita, o usuário continua com acesso regular ao site,
                            até o término do período já contratado. Findo este período, não haverá nova
                            cobrança recorrente, e o acesso ao site será finalmente retirado.</li>
                    </ol>
                </li>
            </ol>
        </li>

        <li>Renovação Antecipada
            <ol>
                <li>Caso o usuário com alguma assinatura ainda em vigor adquira novamente uma
                    assinatura, todos os períodos contratados são mantidos, de modo que a contagem do
                    período da nova assinatura inicia após o término do prazo já contratado da
                    assinatura anterior, como uma renovação antecipada do acesso à plataforma.</li>
                <li>No caso da hipótese acima, não há qualquer tipo de abatimento financeiro.</li>
                <li>O disposto no ítem 1.1 vale também para o caso de adesão feita durante um período
                    promocional, quando as assinaturas são ofertadas em preços inferiores aos praticados
                    ou em condições diferenciadas.</li>
            </ol>
        </li>

        <li>Limitações
            <ol>
                <li>A distribuição de disciplinas e tópicos de cada concurso não necessariamente
                    coincidirá com aquela indicada no edital. A classificação utilizada no Estudei
                    buscará seguir um padrão didático, tendo em vista que os editais de concursos
                    públicos nem sempre seguem um padrão. Exemplificando, caso em um edital o nome da
                    disciplina seja “Língua Portuguesa”, no Estudei esta disciplina pode estar
                    classificada com o nome de “Português”.</li>
                <li>Para consultar a classificação de disciplinas e tópicos adotada pela banca, o
                    usuário deve consultar os arquivos originais dos editais, disponibilizados em nosso
                    site.</li>
                <li>Caso o usuário inclua mais de um edital em seu plano de estudos, o Estudei agrupará
                    as disciplinas comuns a ambos, e mostrará um edital verticalizado editável contendo
                    todas as disciplinas e tópicos das provas escolhidas.</li>
                <li>A Seedy não se obriga a cadastrar os editais de todos os concursos, ou de todos os
                    cargos neles previstos, em nossa plataforma. A Seedy faz sempre uma análise
                    discricionária da viabilidade, tendo em vista aspectos como: demanda dos usuários,
                    previsão de vagas, tempo entre solicitação feita pelo aluno e a data da prova e
                    equipe de cadastradores disponível.</li>
                <li>Os métodos de revisão sugeridos assim como o planejamento criado de forma automática
                    pelo Estudei são apenas sugestões metodológicas, e o usuário concorda que sua
                    aderência não configura uma garantia de aprovação.</li>
                <li>O serviço disponibilizado na plataforma Estudei depende de alguns fatores alheios ao
                    controle da Seedy, como a interação de servidores e serviços de terceiros e a
                    adequação dos equipamentos do usuário, que deve observar os requisitos mínimos para
                    acesso ao serviço.</li>
                <li>A Seedy adotará todas as medidas cabíveis para manter no ar o sistema pelo maior
                    tempo possível, mas o usuário declara estar ciente de que problemas podem ocorrer e
                    a plataforma pode passar por eventuais instabilidades, ficando fora do ar
                    momentaneamente.</li>
                <li>O usuário também declara estar ciente de que a plataforma pode ter funcionalidades
                    atualizadas, adicionadas, removidas ou alteradas a qualquer instante e sem aviso
                    prévio, sem que a ele seja devida qualquer devolução de valores ou indenização a
                    qualquer título.</li>
                <li>A Seedy se reserva no direito de fazer interrupções programadas, suspensões técnicas
                    e/ou operacionais ou, ainda, paradas para manutenção nos serviços online,
                    emergenciais ou não.</li>
            </ol>
        </li>

        <li>Confidencialidade e Privacidade
            <ol>
                <li>O usuário, ao se cadastrar na plataforma, autoriza o Estudei a tratar seus dados
                    pessoais, nos termos do art. 7º, inciso I e art. 8º, caput, da Lei nº 13.709/2018
                    (LGPD).</li>
                <li>Os dados pessoais fornecidos pelo usuário (como CPF, telefone, e-mail e outros) são
                    considerados confidenciais pela Seedy e protegidos por mecanismos de controle de
                    acesso. Não serão, portanto, divulgados a terceiros, com exceção de situações em que
                    tal compartilhamento seja essencial à prestação do serviço como é o caso do gateway
                    de pagamentos e, também, nos casos previstos no art. 7º da Lei nº 13.709/2018
                    (LGPD).</li>
                <li>A Seedy não armazena, em hipótese alguma, dados pessoais sensíveis de seus usuários.
                </li>
                <li>O usuário tem a responsabilidade de manter protegidos seus dados de acesso (login e
                    senha).</li>
                <li>Os dados de pagamento referentes a cartão de crédito não são armazenados pela Seedy.
                    Tais informações, quando usadas na compra de produtos neste site, são processadas
                    somente pela plataforma de vendas (Hotmart) e, assim, as medidas para proteção da
                    informação são de sua inteira responsabilidade.</li>
                <li>Nos termos do art. 18 do Código Civil, o usuário autoriza a Seedy a divulgar seu
                    nome em ações publicitárias em caso de aprovação em qualquer tipo de exame para o
                    qual seja ofertado serviço dentro da plataforma (concursos públicos, OAB, CFC,
                    Vestibulares etc.).</li>
                <li>Os dados relativos às atividades executadas pelos usuários dentro da plataforma
                    poderão ser usados em recursos e ferramentas acessíveis a toda comunidade da Seedy,
                    sendo, sempre que possível, anonimizados.</li>
            </ol>
        </li>

        <li>Condições Gerais
            <ol>
                <li>Em caso de dúvidas, críticas ou sugestões, o usuário pode entrar em contato pelo
                    e-mail <a href="mailto:contato@estudei.com.br">contato&#64;estudei.com.br</a> ou por
                    outros
                    meios de contato disponibilizados no nosso site.</li>
                <li>A tolerância ou o não exercício de quaisquer direitos assegurados neste TERMOS DE
                    USO ou na lei em geral não importará em novação ou em renúncia a qualquer desses
                    direitos, podendo a Seedy e o usuário exercê-los durante a vigência deste TERMOS DE
                    USO.</li>
                <li>Este TERMOS DE USO poderá ser alterado, a qualquer momento, pela Seedy e o usuário
                    será devidamente notificado.</li>
            </ol>
        </li>
    </ol>
</div>